import styled from 'styled-components'

export const Title = styled.div`
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 24px;
`
